import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
};

const approveRecruitmentRequirementSlice = createSlice({
  name: "deleteRecruitmentRequirement",
  initialState,
  reducers: {
    approveRecruitmentRequirementStart: (
      state,
      action: PayloadAction<{ id: string }>
    ) => {
      state.status = ReduxStateType.LOADING;
    },
    approveRecruitmentRequirementSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    approveRecruitmentRequirementFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  approveRecruitmentRequirementStart,
  approveRecruitmentRequirementSuccess,
  approveRecruitmentRequirementFailed,
} = approveRecruitmentRequirementSlice.actions;

export default approveRecruitmentRequirementSlice.reducer;
